import React, { useState, useMemo, useEffect } from 'react'
import { Navigate, Routes, Route, useNavigate } from 'react-router-dom'

import { useDispatch } from 'react-redux'

import Main from 'Layout/Main'
import AppLoader from 'Layout/AppLoader'

import Dashboard from './Dashboard'
import Bots from './Bots'
import Automation from './Automation'
import Content from './Content'
import Training from './Training'
import Apps from './Apps'
import Settings from './Settings'
import ManageAccounts from './ManageAccounts'
import Onboarding from './Onboarding/Onboarding'

import ErrorBoundary from '../../components/ErrorBoundary'

import { useGetMyDataQuery } from 'Services/me'
import { useGetAccountQuery } from 'Services/account'
import { PermissionProvider } from 'Src/b/components/Authorized'

import { fetchCurrentUserSuccess } from 'Actions/users'

const OnboardingRoutes = (props) => {
  return (
    <Routes>
      <Route path='onboarding' element={<Onboarding {...props} />} />
      <Route path='*' element={<Navigate to='onboarding' replace />} />
    </Routes>
  )
}

const ProtectedRouteResolver = (props) => {
  const { account, user } = props
  const { settings } = account
  const [skipOnboarding, setSkipOnboarding] = useState(JSON.parse(localStorage.getItem('skip_onboarding')) || false)
  const navigate = useNavigate()

  const onboardingCompleted = useMemo(() => {
    if (skipOnboarding || settings.onboarding_complete) {
      return true
    }
    return false
  }, [settings.onboarding_complete, skipOnboarding])

  const handleSkipOnboarding = () => {
    localStorage.setItem('skip_onboarding', true)
    setSkipOnboarding(true)
    navigate('/b/dashboard', { replace: true })
  }

  if (!onboardingCompleted) {
    return <OnboardingRoutes onboardingSkipped={handleSkipOnboarding} />
  }

  return (
    <PermissionProvider value={user.permissions}>
      <Routes>
        <Route path='/*' element={<Main />}>
          <Route path='dashboard' element={<Dashboard />} />
          <Route path='bots/*' element={<Bots />} />
          <Route path='automation' element={<Automation />} />
          <Route path='content/*' element={<Content />} />
          <Route path='training' element={<Training />} />
          <Route path='settings/*' element={<Settings />} />
          <Route path='apps/*' element={<Apps />} />
          <Route path='accounts/*' element={<ManageAccounts />} />
          <Route path='*' element={<Navigate to='dashboard' replace />} />
        </Route>
      </Routes>
    </PermissionProvider>
  )
}

const Protected = () => {
  const user = useGetMyDataQuery()
  const account = useGetAccountQuery()
  const isAppLoading = user.isLoading || account.isLoading

  const dispatch = useDispatch()

  useEffect(() => {
    if (user.status === 'fulfilled') {
      dispatch(fetchCurrentUserSuccess(user.data))
    }
  }, [dispatch, user, user.isSuccess])

  return (
    <ErrorBoundary>
      <AppLoader isLoading={isAppLoading}>
        <ProtectedRouteResolver user={user.data} account={account.data} />
      </AppLoader>
    </ErrorBoundary>
  )
}

export default Protected
